var Marionette = require('marionette');
var Entities = require('Entities'); 
var StatusType = EY.Consultation.Lookups.StatusType;
var User = EY.Consultation.CurrentUser;

var Quicklink = Marionette.View.extend({
    tagName: "li",
    events: {
        'click @ui.quicklink': 'navigate'
    },
    template: '#pendingActionQuicklink',
    ui: {
        count: '#count',
        quicklink: '#npolink'
    },
    navigate: function () {
        window.open(EY.Consultation.NpoWeb, "_blank");
    },
    onRender: function () {
        this.ui.count.html(this.options.count);
    }
});

var EligiblilityFilter = {
    $or: [{ completedOn: { $gte: new Date(new Date().setDate(new Date().getDate() - 30)) } },
    { statusTypeId: { $ne: StatusType.Complete } }]
};

var Filter = {
    $or: [{ $and: [{ createdBy: User.upn }, EligiblilityFilter] },
    {
        'approvers.upn': User.upn, statusTypeId: { $ne: StatusType.Draft }, completedOn: { $lt: new Date(new Date().setDate(new Date().getDate() - 30)) },
        $nor: [{ createdBy: User.upn },
        { approvers: { $elemMatch: { approverGroupId: "PartnerInCharge", upn: User.upn } } },
        { approvers: { $elemMatch: { approverGroupId: "EngagementQualityReviewer", upn: User.upn } } },
        { approvers: { $elemMatch: { approverGroupId: "TeamMember", upn: User.upn } } },
        { approvers: { $elemMatch: { approverGroupId: "Reviewer", upn: User.upn } } },
        { approvers: { $elemMatch: { approverGroupId: "RegionalProfessionalPractice", upn: User.upn } } },
        { approvers: { $elemMatch: { approverGroupId: "RegulatoryReviewer", upn: User.upn } } }
        ]
    },
    { $and: [{ approvers: { $elemMatch: { approverGroupId: "RegionalProfessionalPractice", upn: User.upn } } }, { statusTypeId: { $ne: StatusType.Draft } }, EligiblilityFilter] },
    { $and: [{ 'approvers.upn': User.upn }, { statusTypeId: { $ne: StatusType.Draft } }, EligiblilityFilter] },
    {
        $and: [EligiblilityFilter,
            {
                $or: [
                    { approvers: { $elemMatch: { approverGroupId: "PartnerInCharge", upn: User.upn } } },
                    { approvers: { $elemMatch: { approverGroupId: "EngagementQualityReviewer", upn: User.upn } } },
                    { approvers: { $elemMatch: { approverGroupId: "TeamMember", upn: User.upn } } },
                    { approvers: { $elemMatch: { approverGroupId: "Reviewer", upn: User.upn } } }
                ]
            }]
    },
    {
        $and: [EligiblilityFilter, { $nor: [{ statusTypeId: { $eq: StatusType.Draft } }, { statusTypeId: { $eq: StatusType.UsersNotified } }] },
            {
                $or: [
                    { approvers: { $elemMatch: { approverGroupId: "RegulatoryReviewer", upn: User.upn } } },
                    { "crossBorder.nameOfGAPM.upn": User.upn },
                    { "crossBorder.ifrsReviewPerformedBy.upn": User.upn },
                    { "crossBorder.questionGroups": { $elemMatch: { "crossBorderRegulatoryReviewer.upn": User.upn } } }
                ]
            }
        ]

    }
    ]
};

var GeographyFilter = {
    $and: [{
        $or: [{ geographyId: { $regex: User.geographyByRole['CountryAdministrator'] } },
        { $and: [{ geographyTypePath: '/Area/Region/Country/SubCountry/', geographyId: { $regex: User.geographyByRole['RegionalProfessionalPractice'] } }, { statusTypeId: { $ne: StatusType.Draft } }] },
        { $and: [{ geographyTypePath: '/Area/Region/Country/SubCountry/', geographyId: { $regex: User.geographyByRole['CapitalMarketsProfessionals'] } }, { statusTypeId: { $ne: StatusType.Draft } }] },
        { $and: [{ geographyTypePath: '/Area/Region/Country/SubCountry/', geographyId: { $regex: User.geographyByRole['NotifiedRegionalRoles'] } }, { statusTypeId: { $ne: StatusType.Draft } }] },
        { $and: [{ geographyTypePath: '/Area/Region/Country/SubCountry/', geographyId: { $regex: User.geographyByRole['CapitalMarketsAreaLeaders'] } }, { statusTypeId: { $ne: StatusType.Draft } }] },
        ]
    }
    ]
};
module.exports.show = function (options) {
    var region = options.region;

    var npoRecords = new Entities.NpoRecords();

    npoRecords.fetch({
        //filter: { assignedTo: User.upn } 
        aggregate: [{
            //$match: { assignedTo: User.upn } 
            $match: { $or: [Filter, GeographyFilter] }
        }]
    }).done(function () {
        if (npoRecords.length > 0) {
            var pendingRecords = npoRecords.where({ assignedTo: User.upn }).length;
            var count = pendingRecords > 0 ? pendingRecords : 0;
            if (npoRecords.length > 0) {
                region.show(new Quicklink({ count: count }));
            }
        }
        });

};


// WEBPACK FOOTER //
// ./js/Modules/Home/HomeNpoQuicklink.js